function getUrlParameter(url, name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(url);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

var skuEl = document.getElementById("js-farmet-sku");
var $basketForm = $("#js-farmet-basket-form");

//var domain = 'http://localhost:54624';
var domain = "https://www.farmet.cz";

var basketAddUrl = domain + "/cs/basket/addv2";
var skuInfoUrl = domain + "/cs/basket/skuInfov2";

$(function () {
    $("#js-farmet-basket-count-inc").on("click", function () {
        $("#js-farmet-basket-count").val($("#js-farmet-basket-count").val() * 1 + 1);
    });
    $("#js-farmet-basket-count-dec").on("click", function () {
        var val = $("#js-farmet-basket-count").val() * 1;
        if (val > 1) {
            $("#js-farmet-basket-count").val(val - 1);
        }
    });


    DMP.Book.renderer.hotspotClickHandler = function (href) {
        if (href.indexOf("/basket/add?sku=") != -1) {
            var erpID = getUrlParameter(href, "sku");
            if (erpID) {
                skuEl.value = erpID;
                var popup = $("#js-farmet-popup");

                popup.find("#js-farmet-basket-popup-message-wrapper").hide();
                popup.find("#js-farmet-basket-form").show();
                popup.find("#js-farmet-basket-close").hide();
                popup.find("#js-farmet-basket-popup-product-title").text("");
                popup.find("#js-farmet-basket-popup-product-code").text("");
                popup.find("#js-farmet-sku").val("");
                popup.find("#js-horizont-product-image-wrapper").hide();
                popup.find("#js-farmet-basket-popup-product-image").text("");
                popup.find("#js-farmet-basket-popup-product-is-spare-part").hide();

                $.ajax({
                    url: skuInfoUrl + "?sku=" + erpID,
                    success: function (response) {
                        handleFarmetResponse(response);
                    },
                });

                $("#modal-farmet-buy").modal("show");
            } else {
                window.open(href);
            }
        }
    };

    $basketForm.submit(function (ev) {
        ev.preventDefault();

        var data = $(this).serialize();

        var url = basketAddUrl + "?" + data;

        $.ajax({
            type: "GET",
            url: url,
            data: data,
            dataType: "json",
            xhrFields: { withCredentials: true },
            crossDomain: true,
            success: function (response) {
                handleFarmetResponse(response);
                $("#js-farmet-basket-form").hide();
                $("#js-farmet-basket-close").show();
            },
        });
    });

    $(document).on("click", ".js-alert-lang", function () {
        var activCls = "alert-tabs__item--active";

        $(".js-alert-lang").removeClass(activCls);

        var activeTab = $(this);

        activeTab.addClass(activCls);

        var lang = activeTab.data("lang");

        $(".js-alert-msg").hide();
        $(".js-alert-msg[data-lang=" + lang + "]").show();
    });
});

function handleFarmetResponse(data) {
    var popup = $("#js-farmet-popup");

    if (data.Status) {
        popup.find("#js-farmet-basket-popup-product-title").text(data.Name);
        popup.find("#js-farmet-basket-popup-product-code").text(data.ErpID);
        popup.find("#js-farmet-sku").val(data.ErpID);

        if (data.ImageUrl) {
            popup.find("#js-horizont-product-image-wrapper").show();
            popup.find("#js-farmet-basket-popup-product-image").text(data.ImageUrl);
        }

        if (data.IsSparePart) {
            popup.find("#js-farmet-basket-popup-product-is-spare-part").show();
        }
    }

    if (data.Message) {
        $.each(data.Message, function (i, v) {
            var lang = v.Language;
            $(".js-alert-msg[data-lang=" + lang + "]").text(v.Message);
        });

        popup.find("#js-farmet-basket-popup-message-wrapper").show();
    }
}